import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import DialogInput from 'screens/components/advanced/DialogInput';
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import DialogHeader from 'screens/components/basic/DialogHeader'
import { initializeStoreDiscount } from 'actions/FormActions';
import { discountVisitOrder, alpineIQregister, alpineIQverifyWallet, alpineIQviewWallet, postAlpineIQDiscount } from 'actions/EntityActions';

const dialogStyle = {
    width: '65%',
    maxWidth: 'none'
};

class POSAlpineIQRewardsDialog extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            errorMessage: "",
            selectedDiscount: null,
            discountDetailDialogOpen: false
        };
    }

    componentWillMount() {
        if (this.props.order && this.props.order.patientPhoneNumber && this.props.order.patientPhoneNumber.length > 0 && !this.props.alpineIQwalletCode) {
            let mobilePhone = this.props.order.patientPhoneNumber;

            let model = { phoneNumber: mobilePhone, orderNumber: this.props.order.id, branchId: this.props.branchId };
            this.props.alpineIQverifyWallet(model);
        }
        this.setState({ errorMessage: "" });
    }

    Register = () => {
        if (this.props.order && this.props.order.patientPhoneNumber && this.props.order.patientPhoneNumber.length > 0) {
            let mobilePhone = this.props.order.patientPhoneNumber;
            let firstName = this.props.order.patientFirstName;
            let lastName = this.props.order.patientLastName;
            let email = this.props.order.patientEmail;

            let model = { mobilePhone: mobilePhone, firstName: firstName, lastName: lastName, email: email, branchId: this.props.branchId, orderNumber: this.props.order.id };
            this.props.alpineIQregister(model);
            this.props.onClose();
        }
        else {
            this.setState({ errorMessage: "Please add your mobile phone number to your profile" })
        }
    }

    GetRewards = () => {
        if (this.props.code && this.props.code.length == 4) {
            let mobilePhone = this.props.order.patientPhoneNumber;

            let model = { phoneNumber: mobilePhone, branchId: this.props.branchId, code: this.props.code, email: this.props.order.patientEmail }
            this.props.alpineIQviewWallet(model);
        }
        else {
            this.setState({ errorMessage: "Code must be 4 digits" })
        }
    }

    closeDiscountDetailDialog = () => {
        this.setState({
            discountDetailDialogOpen: false
        });
    }

    checkDetails = (discount) => {
        this.setState({
            discountDetailDialogOpen: true,
            selectedDiscount: discount
        });
    }

    addToOrder = (discount) => {
        let p = this.props;
        const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));

        let percentage = discount.percentageValue;
        let amount = discount.dollarValue;

        let orderProductDiscountPoints = 0;
        if(p.order && p.order.products)
        {
            p.order.products.map((product) => {
                orderProductDiscountPoints = orderProductDiscountPoints + product.alpineIQRewardPoints;
            });
        }

        if(this.props.alpineIQPoints - orderProductDiscountPoints < discount.pointsDeduction)
        {
            alert("Unable to redeem - Due to currently applied discounts, the customer does not have enough points to redeem discount(s)");
            return;
        }

        if(p.order && p.order.products)
        {
            let existingProduct = false;
            p.order.products.map((product) => {
                if(discount.redemptionURL == product.alpineIQRedeemURL)
                {
                    existingProduct = true;
                }
            });
            if(existingProduct) {
                alert("Cannot apply the same discount twice");
                return;
            }
        }

        if(p.order && p.order.discounts)
        {
            let existingDiscount = false;
            p.order.discounts.map((orderDiscount) => {
                if(discount.redemptionURL == orderDiscount.alpineIQRedeemURL)
                {
                    existingDiscount = true;
                }
            });
            if(existingDiscount) {
                alert("Cannot apply the same discount twice");
                return;
            }
        }

        let model = {
            Id: this.props.order ? this.props.order.id : 0, BranchId: this.props.branchId,
            DeviceId: deviceData.id, Percentage: percentage,
            Amount: amount, Notes: "Alpine IQ Discount",
            DiscountId: discount.id ? discount.id : 0, PatientId: this.props.order ? this.props.order.patientId : 0,
            ReedeemURL: discount.redemptionURL,
            points: discount.pointsDeduction,
            posDiscountID: discount.posDiscountID
        };

        this.props.postAlpineIQDiscount(model);
        this.props.onClose();
    }

    onClose = () => {
        this.props.onClose();
        this.props.initializeStoreDiscount();
        this.setState({ errorMessage: "" })
    }

    render() {
        const { t } = this.props;
        const p = this.props;
        let discounts = this.props.wallet;
        let selectedDiscount = this.state.selectedDiscount;

        return (
            <div>
                <DialogInput
                    title={<DialogHeader text={t('pos.alpineIQRewardsDialog.alpineDiscounts')} />}
                    modal={true}
                    open={p.open}
                    autoScrollBodyContent={true}
                    contentStyle={dialogStyle}
                    actions={[
                        <Button
                            key={2}
                            type="CancelButton"
                            name="buttonCancel"
                            className="btn-space"
                            label={t('common.cancel')}
                            onTouchTap={() => this.onClose()} />
                    ]}>

                    {p.order && !(p.order.patientPhoneNumber || p.order.patientEmail) && !discounts && <div>{t('pos.alpineIQRewardsDialog.assignPhoneOrEmail')}</div>}

                    {p.order && (p.order.patientPhoneNumber || p.order.patientEmail) && p.alpineIQverify != p.order.id && !discounts && (this.props.alpineIQPoints == undefined || this.props.alpineIQPoints == null) && <div>
                        <p>{t('pos.alpineIQRewardsDialog.consentParagraph', { branchName: this.props.branchName})}</p>
                        <Button
                            key={1}
                            name="Register"
                            label={t('pos.alpineIQRewardsDialog.register')}
                            primary={true}
                            onTouchTap={() => this.Register()} />
                        <div>{this.state.errorMessage}</div>
                    </div>}

                    {p.order && p.order.patientPhoneNumber && p.alpineIQverify == p.order.id && !discounts &&
                        <div>
                            <div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <br />
                                        <div className="pos-online-order-code">
                                            <p>{t('pos.alpineIQRewardsDialog.enter2FA')}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-3 text-left">
                                    <br />
                                    <TextInput
                                        type="number"
                                        name={`${p.name}code`}
                                        label={t('pos.alpineIQRewardsDialog.code')}
                                        hintText={t('pos.alpineIQRewardsDialog.code')}
                                    />
                                    <Button
                                        key={1}
                                        name="GETDISCOUNTS"
                                        label={t('pos.alpineIQRewardsDialog.getDiscounts')}
                                        primary={true}
                                        onTouchTap={() => this.GetRewards()} /> <span>{this.state.errorMessage}</span>
                                </div>
                                <div className="col-lg-3 text-left">

                                </div>
                            </div>
                        </div>
                    }

                    {p.order && (p.order.patientPhoneNumber || p.order.patientEmail) && p.alpineIQverify != p.order.id && !discounts && (this.props.alpineIQPoints != undefined || this.props.alpineIQPoints != null) && <div>
                        {this.props.firstName && this.props.lastName && <h1>{this.props.firstName} {this.props.lastName} has {this.props.alpineIQPoints} points</h1>}
                        <h2>{t('pos.alpineIQRewardsDialog.notEnoughPoints')}</h2>
                        
                    </div>}

                    {discounts && discounts.length > 0 &&

                        <div>
                            {this.props.firstName && this.props.lastName && <h1>{this.props.firstName} {this.props.lastName} has {this.props.alpineIQPoints ? this.props.alpineIQPoints : "0"} points</h1>}
                            <div className="row m-0">
                                {
                                    (discounts !== undefined && discounts !== null) &&
                                    discounts.filter(x => x.type == 1 || x.type == 0).map((discount, index) => {
                                        let redeemValid = this.props.order && this.props.order.subTotal && this.props.order.subTotal <= 0.0 || (this.props.order && this.props.order.subTotal && discount.dollarValue > this.props.order.subTotal && discount.percentageValue <= 0.0);
                                        return (
                                            <div key={index} className="item-online-order">
                                                <div className="col-lg-4 col-sm-4 col-xs-4 col-md-4 mt-2">
                                                    <div>
                                                        {discount.name}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-sm-4 col-xs-4 col-md-4 btn-start">
                                                    <Button
                                                        name="finishButton"
                                                        label={t('common.viewDetails')}
                                                        className="pull-right btn-finish"
                                                        primary={true}
                                                        onTouchTap={() => this.checkDetails(discount)}
                                                    />
                                                </div>
                                                <div className="col-lg-4 col-sm-4 col-xs-4 col-md-4 btn-start">
                                                    <Button
                                                        name="finishButton"
                                                        label={t('common.redeem')}
                                                        className="pull-right btn-load-create-order"
                                                        primary={true}
                                                        onTouchTap={() => this.addToOrder(discount)}
                                                        disabled={redeemValid}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <DialogInput 
                                title={<DialogHeader text={selectedDiscount ? selectedDiscount.name : ""} classicClass="posDialogClassic"/>}
                                modal={true}
                                open={this.state.discountDetailDialogOpen}
                                autoScrollBodyContent={true}
                                className="online-orders-line-dialog checkIn_list"
                                handleClose={() => this.closeDiscountDetailDialog()}
                            >
                                {selectedDiscount ?
                                    <div>
                                        <div className='text-center'>
                                            {selectedDiscount.dollarValue > 0 && <h4>{t('common.discountAmount')}${selectedDiscount.dollarValue}</h4>}
                                            {selectedDiscount.percentageValue > 0 && <h4>{t('common.discountPerc')}{selectedDiscount.percentageValue}%</h4>}
                                            {selectedDiscount.pointsDeduction > 0 && <h4>{t('pos.alpineIQRewardsDialog.pointsDeducted')}{selectedDiscount.pointsDeduction} </h4>}
                                            {selectedDiscount.posDiscountID != "" && <h4>{t('pos.alpineIQRewardsDialog.techPosProductId')}{selectedDiscount.posDiscountID} </h4>}
                                            ----------------------------------------------------------------
                                            <p>{selectedDiscount.pageTitle}</p>
                                            {(this.props.order && selectedDiscount.dollarValue > this.props.order.subTotal && selectedDiscount.percentageValue <= 0.0) && <p className="danger">{t('pos.alpineIQRewardsDialog.subTotalRedeemDiscount')}</p>}
                                        </div>

                                        <Button name="buttonCancel"
                                            type="Button"
                                            className="corner_X"
                                            label=""
                                            onTouchTap={() => this.closeDiscountDetailDialog()}
                                        />
                                    </div> : ""}

                            </DialogInput>
                        </div>
                    }
                </DialogInput>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        deviceKeyName: state.common.applicationSettings.deviceKeyName,
        code: state.form[`${ownProps.name}code`],
        order: state.entity.posOrder,
        branchId: state.common.branchId,
        alpineIQverify: state.entity.alpineIQverify || 0,
        alpineIQPoints: state.entity.alpineIQPoints,
        branchName: state.common.store.name,
        wallet: state.entity.alpineIQwallet,
        firstName: state.entity.posOrder ? state.entity.posOrder.patientFirstName : '',
        lastName: state.entity.posOrder ? state.entity.posOrder.patientLastName : '',
        alpineIQwalletCode: state.common.applicationSettings.alpineIQwalletCode || ""
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        discountVisitOrder: (model) => dispatch(discountVisitOrder(model, ownProps.name)),
        formError: (name, error) => dispatch(formError(name, error)),
        initializeStoreDiscount: () => dispatch(initializeStoreDiscount(ownProps.name, 'POSProductDiscount')),
        alpineIQregister: (model) => dispatch(alpineIQregister(model)),
        alpineIQverifyWallet: (model) => dispatch(alpineIQverifyWallet(model)),
        alpineIQviewWallet: (model) => dispatch(alpineIQviewWallet(model)),
        postAlpineIQDiscount: (model) => dispatch(postAlpineIQDiscount(model))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSAlpineIQRewardsDialog));
